import BasicModal from "@/modules/common/components/modals/basic-modal";
import { muiTheme } from "@/styles/theme";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const FeedBackModal = ({
  setOpen,
  open,
  message,
  handleOnClickOk,
  failure,
  title,
}: {
  setOpen: (boolean: boolean) => void;
  open: boolean;
  message?: string;
  handleOnClickOk: () => void;
  failure?: boolean;
  title?: string;
}) => {
  return (
    <>
      <BasicModal open={open} setOpen={setOpen} width={450} height={320}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 3,
            padding: 2,
            borderRadius: 2,
          }}
        >
          {failure ? (
            <Box
              sx={{
                width: "60px",
                height: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FAC5C1",
                borderRadius: 2,
              }}
            >
              <CancelOutlinedIcon
                sx={{
                  width: "30px",
                  height: "30px",
                  color: "#000000",
                }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                width: "60px",
                height: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#B6E9D1",
                borderRadius: 2,
              }}
            >
              <CheckCircleOutlineOutlinedIcon
                sx={{
                  width: "30px",
                  height: "30px",
                  color: "#000000",
                }}
              />
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "center",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Typography variant="h3_med">{title}</Typography>
            <Typography variant="body_md_reg">{message}</Typography>
          </Box>
          <Button
            variant="contained"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              borderRadius: 2,
              color: " #344054",
              border: "1px solid #D0D5DD",
              width: "120px",
              height: "44px",
              background: muiTheme.colorSchemes.light.palette.background.white,
              boxShadow: "0px 0px 0px 0px rgba(16, 24, 40, 0.05)",
              textTransform: "none",
              "&:hover": {
                background: "#F9FAFB",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              },
              "&:active": {
                boxShadow:
                  "0px 0px 0px 4px #F2F4F7, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              },
            }}
            onClick={handleOnClickOk}
          >
            <Typography
              sx={{
                color: "#344054",
                fontWeight: 600,
              }}
              variant="h6"
            >
              OK
            </Typography>
          </Button>
        </Box>
      </BasicModal>
    </>
  );
};

export default FeedBackModal;
